import { Brick, registerBrick } from 'olympe';

export default class IsThisMonday extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {!Array} outputs
     */
    update($, inputs, [setIsTodayMonday]) {
        // Write your code here.
        // Check https://olympe.support for documentation.
        // Check https://github.com/olympeio/CORE for examples.
        //
        const currentDate = new Date()
        setIsTodayMonday(currentDate.getDay() === 1)
    }
}

registerBrick('019eb5cd6dc4841a69df', IsThisMonday);
